import { h } from 'preact';
import Beans3 from '@/beans';
import { riperStorage, Utils } from '@/base/helpers';
import { Event, Widget } from '@/liana/helpers';

const Redemption = {
  load() {
    let redeem;
    let cart;

    try {
      const beansCjs = Beans3._utils.getCookie('beans_cjs');
      redeem = beansCjs.redeem;
      cart = beansCjs.cart;
    } catch (error) {
      // Ignore error
    }

    if (redeem) {
      riperStorage.coupon = {
        uid: redeem.code,
        amount: redeem.beans / 100,
        beans: redeem.beans,
        message: redeem.message,
      };
      Event.dispatchRedemption({ coupon: riperStorage.coupon });
    } else {
      riperStorage.coupon = null;
      Event.dispatchRedemption({ coupon: riperStorage.coupon });
    }
    riperStorage.cart = cart;
    Event.dispatchRedemption({ cart });
    Widget.showMessageDefault(true);
  },
  apply(tierID) {
    Widget.showMessageDefault(true);
    Event.dispatchRedemption({ status: 'pending:apply' });
    if (tierID) return Utils.formPost('', { beans_action: 'apply', tier_id: tierID });
    return Utils.formPost('', { beans_action: 'apply' });
  },

  cancel() {
    Widget.showMessageDefault(true);
    Event.dispatchRedemption({ status: 'pending:cancel' });
    return Utils.formPost('', { beans_action: 'cancel' });
  },
};

export default Redemption;
